import { Col } from "@amzn/stencil-react-components/layout";
import { Link, LinkTextDecorationOptions } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React, { useState } from "react";

export interface FacetedFilterProps {
  title: string;
  filterName: string;
  options: string[];
  addFacetFilter: (filter: { field: string; value: string }) => void;
}

const HardwareFacetedFilter = (props: FacetedFilterProps) => {
  const { filterName, title, options, addFacetFilter } = props;

  const [selectedFacet, setSelectedFacet] = useState<string>("");

  const handleFacetClick = (facetValue: string) => {
    setSelectedFacet(facetValue);
    addFacetFilter({ field: filterName, value: facetValue });
  };

  const handleAllOptionsClick = () => {
    setSelectedFacet("");
    addFacetFilter({ field: filterName, value: "" });
  };

  const getFacetOptions = () =>
    options.map((name) => (
      <Link
        data-testid="facet-option"
        textDecoration={LinkTextDecorationOptions.None}
        key={name}
        href="#"
        onClick={() => handleFacetClick(name)}
        color="neutral90"
        margin={["S300", 0, 0, 0]}
        padding={[0, 0, 0, "S500"]}
        fontWeight={selectedFacet === name ? "bold" : "regular"}
      >
        {name}
      </Link>
    ));

  return (
    <Col data-testid="hardware-facet" padding={[0, 0, "S700", 0]}>
      <Text color="neutral70" margin={["S300", 0, 0, "S500"]} data-cy="facet-filter-title">
        {title}
      </Text>
      <Link
        textDecoration={LinkTextDecorationOptions.None}
        fontWeight={selectedFacet === "" ? "bold" : "regular"}
        href="#"
        color="neutral90"
        margin={["S300", 0, 0, 0]}
        padding={[0, 0, 0, "S500"]}
        onClick={handleAllOptionsClick}
      >
        {"All"}
      </Link>
      {getFacetOptions()}
    </Col>
  );
};

export default HardwareFacetedFilter;
